/**
 * Detect fn
 */
export default () => 'Symbol' in self && 'toStringTag' in self.Symbol
